var map = {
	"./featured-item/coach@2x.png": 166,
	"./featured-item/cuff@2x.png": 170,
	"./featured-item/fastclix_lancets@2x.png": 174,
	"./featured-item/fastclix_lancing_kit@2x.png": 178,
	"./featured-item/guide@2x.png": 182,
	"./featured-item/guide_me@2x.png": 186,
	"./featured-item/mysugr_coach_voucher_based_1@2x.png": 190,
	"./featured-item/pro@2x.png": 194,
	"./featured-item/scale@2x.png": 198,
	"./featured-item/softclix_lancets@2x.png": 202,
	"./featured-item/softclix_lancing_kit@2x.png": 206,
	"./featured-item/strips_subscription_guide@2x.png": 210,
	"./item/coach@2x.png": 267,
	"./item/cuff@2x.png": 269,
	"./item/fastclix_lancets@2x.png": 271,
	"./item/fastclix_lancing_kit@2x.png": 273,
	"./item/guide@2x.png": 275,
	"./item/guide_me@2x.png": 277,
	"./item/guide_strips@2x.png": 279,
	"./item/mysugr_coach_voucher_based_1@2x.png": 281,
	"./item/pro@2x.png": 283,
	"./item/scale@2x.png": 285,
	"./item/softclix_lancets@2x.png": 287,
	"./item/softclix_lancing_kit@2x.png": 289,
	"./item/strips_subscription_guide@2x.png": 291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;